module.exports = __webpack_public_path__ + "static/media/school-logo.fdd3b4bb.png";